import { render, staticRenderFns } from "./ContentInputs.vue?vue&type=template&id=04f5e283&"
import script from "./ContentInputs.vue?vue&type=script&lang=ts&"
export * from "./ContentInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports